<template>
  <div class="controlpanel-page controlpanel-page-pdt0">
    <div class="uploadreporttopbar">
      <h1>创建行业报告 - 报告命名</h1>
      <el-divider></el-divider>
    </div>

    <div class="createindustry-body">
      <div class="createindustry-step">
        <div class="createindustry-name" v-if="createstep == 1">
          <form id="reportformid" enctype="multipart/form-data">
            <div class="createindustry-form">
              <div class="createindustry-form-item">
                <div class="createindustry-form-label">所属行业</div>
                <div class="createindustry-form-input">
                  <el-select v-model="reportobj.iid" placeholder="请选择">
                    <el-option
                      v-for="item in industrylist"
                      :key="item.iid"
                      :label="item.name_cn + '/' + item.name_en"
                      :value="item.iid">
                    </el-option>
                  </el-select>
                  <input type="hidden" v-model="reportobj.iid" name="iid" />
                </div>
              </div>
              <div class="createindustry-form-item">
                <div class="createindustry-form-label">报告命名 - 中文</div>
                <div class="createindustry-form-input">
                  <input type="text" name="name_cn" v-model="reportobj.name_cn" />
                </div>
              </div>
              <div class="createindustry-form-item">
                <div class="createindustry-form-label">报告命名 - 英文</div>
                <div class="createindustry-form-input">
                  <input type="text" name="name_en" v-model="reportobj.name_en" />
                </div>
              </div>
              <div class="createindustry-form-item">
                <div class="createindustry-form-label">上传代码</div>
                <div class="createindustry-form-input">
                  <input ref="fileinput" type="file" name="xlsx" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- <div class="createindustry-description" v-if="createstep == 2">
          <div class="createindustry-form">
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">包含代码数量</div>
              <div class="createindustry-form-input">
                <input type="text" v-model="reportobj.totalcode" />
              </div>
            </div>
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">品类包括(中文)</div>
              <div class="createindustry-form-input">
                <textarea v-model="reportobj.categorydesc_cn"></textarea>
              </div>
            </div>
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">品类包括(英文)</div>
              <div class="createindustry-form-input">
                <textarea v-model="reportobj.categorydesc_en"></textarea>
              </div>
            </div>
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">说明(中文)</div>
              <div class="createindustry-form-input">
                <textarea v-model="reportobj.description_cn"></textarea>
              </div>
            </div>
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">说明(英文)</div>
              <div class="createindustry-form-input">
                <textarea v-model="reportobj.description_en"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="createindustry-code" v-if="createstep == 3">
          <div class="createindustry-form">
            <div class="createindustry-form-item">
              <div class="createindustry-form-label">上传代码</div>
              <div class="createindustry-form-input">
                <input type="file" name="xlsx" />
              </div>
            </div>
          </div>
        </div> -->
        <div class="createindustry-preview" v-if="createstep == 2">
          Dashboard预览链接
        </div>
      </div>
    </div>

    <div class="createindustry-footer">
      <el-button type="primary" size="mini" v-if="createstep == 1" @click="gotoManagementPage">取消</el-button>
      <el-button type="primary" size="mini" v-if="createstep > 1 && createstep < 3" @click="prevStep">上一步</el-button>
      <el-button type="primary" size="mini" v-if="createstep < 2" @click="nextStep">下一步</el-button>
      <el-button type="primary" size="mini" v-if="createstep == 2" @click="publishReport">发布</el-button>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      industrylist: [],
      reportobj: {
        name_cn: '',
        name_en: ''
      },
      createstep: 1,
      uploadurl: ''
    }
  },

  mounted(){
    this.uploadurl = 'http://dashboard.api.trade-intelligence.com/admin/category/index' + 
                '?token=' + this.getLocalStorage('admintoken')
    this.getIndustryList()
  },

  methods: {

    /**
     * 取消添加代码
     */
    gotoManagementPage: function(){
      this.reportobj = {}
      this.$router.push({ name: "ReportManagement" })
    },

    /**
     * 下一步
     */
    nextStep: function(){
      this.createstep += 1
      this.addCategoryReport()
    },

    /**
     * 上一步
     */
    prevStep: function(){
      this.createstep -= 1
    },

    /**
     * 发布报告
     */
    publishReport: function(){
      this.reportobj = {}
      this.$router.push({ name: "ReportManagement" })
    },

    /**
     * 获取行业列表
     */
    getIndustryList: function(){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/index' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          that.industrylist = rex.data.data
        },
        error: function(response) {
          console.log(response)
        }
      })                 
    },

    /**
     * ADD行业报告
     * Excel上传
     */
    addCategoryReport: function(){
      let that = this
      let formdata = new FormData(document.getElementById('reportformid'))
      // let _form = that.$refs.fileinput.files[0]
      // formdata.append('iid', that.reportobj.iid)
      // formdata.append("name_cn", 'aa')
      // formdata.append("name_en", 'cc')
      // formdata.append('xlsx', _form)
      formdata.forEach(item => {
        console.log(item)
      })
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/add' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax({  
        url: url,
        type: 'POST',  
        dataType: 'json',
        data: formdata,  
        async: false,  
        cache: false,  
        contentType: false,
        processData: false,
        success: function(rex) {
          console.log(rex)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

  }
}
</script>